import { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { preloadRoute } from "../LazyImports";
import { useStores } from "@/hooks/useStores";

const PODCAST_PATH = /^\/podd\/([^/?#]+)$/;

/** A Link that starts loading its target's code (and a podcast's data) on hover or focus. */
export const PrefetchLink = ({ to, onPointerEnter, onFocus, ...props }: ComponentProps<typeof Link>) => {
    const { podcastStore } = useStores();

    const prefetch = () => {
        if (typeof to !== "string") return;
        preloadRoute(to);
        const slug = PODCAST_PATH.exec(to)?.[1];
        if (slug) {
            podcastStore.prefetchPodcastBySlug(decodeURIComponent(slug));
        }
    };

    return (
        <Link
            to={to}
            onFocus={(event) => {
                prefetch();
                onFocus?.(event);
            }}
            onPointerEnter={(event) => {
                prefetch();
                onPointerEnter?.(event);
            }}
            {...props}
        />
    );
};
